export default __webpack_public_path__ + "static/media/step4.d48e036b.png";